import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  fetchTopBanners,
  fetchTopBannersSuccess,
  fetchTopBannersFailure,
  fetchLastUpdates,
  fetchLastUpdatesSuccess,
  fetchLastUpdatesFailure, fetchGroupDetails, fetchGroupDetailsSuccess, fetchGroupDetailsFailure
} from './dashboard.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { DashboardService } from '@services/dashboard/dashboard.service';

@Injectable()
export class DashboardEffects {
  loadTopBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTopBanners),
      mergeMap(action =>
        this.dashboardService.getTopBanners().pipe(
          map(res => {
            return fetchTopBannersSuccess({ topBanner: res });
          }),
          catchError(error => {
            return of(fetchTopBannersFailure({ error }));
          })
        )
      )
    )
  );

  loadLastUpdates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchLastUpdates),
      mergeMap(action =>
        this.dashboardService.getLastUpdates().pipe(
          map(res => {
            return fetchLastUpdatesSuccess({ payload: res });
          }),
          catchError(error => {
            return of(fetchLastUpdatesFailure({ error }));
          })
        )
      )
    )
  );

  loadGroupDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchGroupDetails),
      mergeMap(action =>
        this.dashboardService.getGroupDetails().pipe(
          map(res => {
            return fetchGroupDetailsSuccess({ payload: res });
          }),
          catchError(error => {
            return of(fetchGroupDetailsFailure({ error }));
          })
        )
      )
    )
  );


  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService
  ) {}
}
